import { Inject, Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AccountInfo, AuthenticationResult, EventMessage, EventType, RedirectRequest } from '@azure/msal-browser';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '../../../environments/environment';

Injectable({
  providedIn: 'root'
})

@Injectable()
export class AppstateService {
  private msalBroadcastService = inject(MsalBroadcastService);
  private authService = inject(MsalService);
  private translateService = inject(TranslateService);

  private readonly _destroy$ = new Subject<void>();

  collapsed = signal<boolean>(true);
  isUserLoggedIn = signal<boolean>(false);
  account = signal<AccountInfo | null>(null);
  version = signal<string>("v1.0.0");

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, private http: HttpClient) { }

  init(): void {
    this.subscribeAuthentication();
    this.configureTranslation();
    this.fetchVersion()
  }

  fetchVersion(): void {
    const url = `${environment.apiurl}/info/build`;
    this.http.get<{ act: string, db: string }>(url)
      .subscribe(response => {
        this.version.set("<pre>p" + response.act + "</pre><pre>d" + response.db + "</pre>");
      });
  }

  private configureTranslation() {
    this.translateService.setDefaultLang('en');
    this.translateService.use('de');
  }

  private subscribeAuthentication() {
    this.authService.handleRedirectObservable().subscribe();

    this.msalBroadcastService.msalSubject$.pipe(
      takeUntil(this._destroy$)
    ).subscribe((msg: EventMessage) => {
      if (msg.eventType === EventType.HANDLE_REDIRECT_END) {
        if (!this.authService.instance.getActiveAccount()) {
          this.isUserLoggedIn.set(false);
          this.account.set(null);
        } else {
          this.isUserLoggedIn.set(true);
          this.account.set(this.authService.instance.getActiveAccount());
        }
      } else if (msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
        const payload = msg.payload as AuthenticationResult;

        this.account.set(payload.account);
        this.authService.instance.setActiveAccount(this.account());
      }
    });
  }

  login() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  logout() {
    this.authService.logoutRedirect();
  }

  Destroy(): void {
    this._destroy$.next(undefined);
    this._destroy$.complete();
  }
}
